// extracted by mini-css-extract-plugin
export var messageSideLeft = "_je-1";
export var messageSideRight = "_je-2";
export var orderLookupBubbleContainer = "_je-0";
export var submitButton = "_je-3";